<template>
    <rkm-area
        background-color="secondary"
        header-prefix-icon="check-circle"
        title="Finalização do atendimento"
        type="box"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-radio-group
                    :options="data.form.demandaTipos"
                    disabled
                    label="Tipo de demanda"
                    v-model="data.model.demandaTipo"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="!!data.model.demandaTipo">
            <rkm-col cols="12">
                <rkm-form-radio-group
                    :options="atendimentoTipos"
                    :validations="validations.atendimentoTipo"
                    label="Tipo de atendimento"
                    text-field="nome"
                    v-model="data.model.atendimentoTipoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-input-autocomplete
                    :repository="repositories.usuario"
                    :search-fields="fields.usuario"
                    :text-field="value => `${value.cidadaoNome}${value.cidadaoCns ? ' - ' + formatCns(value.cidadaoCns) : null}`"
                    label="Atendimento compartilhado"
                    v-model="data.model.atendimentoCompartilhadoUsuario"
                />
            </rkm-col>
        </rkm-row>

        <BoxProcedimentoAdministrativo :data="data" />

        <BoxCasoSuspeito
            :data="data"
            class="mt-3"
        />

        <rkm-row class="mt-3">
            <rkm-col cols="12">
                <rkm-form-select
                    :options="data.form.racionalidadesSaude"
                    label="Racionalidade em saúde (Exceto alopatia/convencional)"
                    show-default-option
                    text-field="descricao"
                    v-model="data.model.racionalidadeSaudeId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-select
                    :options="data.form.equipes"
                    label="Equipe"
                    show-default-option
                    text-field="descricao"
                    v-model="data.model.equipeId"
                    value-field="id"
                    :validations="validations.equipe"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="data.form.turnos"
                    :validations="validations.turno"
                    label="Turno"
                    text-field="nome"
                    v-model="data.model.turnoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="data.form.locaisAtendimento"
                    :validations="validations.atencaoBasicaLocalAtendimento"
                    label="Local de atendimento"
                    text-field="descricao"
                    v-model="data.model.atencaoBasicaLocalAtendimentoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-checkbox-group
                    :options="data.form.condutas"
                    :validations="validations.condutas"
                    label="Condutas"
                    text-field="descricao"
                    v-model="data.model.condutas"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="data.additionals.precisaInformarConclusaoTratamento">
            <rkm-col cols="12">
                <rkm-form-radio-group
                    :validations="validations.isTratamentoConcluido"
                    label="Conclusão de tratamento"
                    v-model="data.model.isTratamentoConcluido"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>
        </rkm-row>

        <rkm-area
            v-if="data.additionals.criaFichaAtencaoBasicaAtendimentoDomiciliar"
            background-color="secondary"
            title="Atendimento domiciliar - EMAD"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-select
                        :options="data.form.tiposAtendimento"
                        :validations="validations.emadTipoAtendimento"
                        label="Tipo de atendimento"
                        show-default-option
                        text-field="descricao"
                        v-model="data.model.emadTipoAtendimentoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="data.form.modalidades"
                        :validations="validations.emadModalidade"
                        label="Modalidade"
                        show-default-option
                        text-field="descricao"
                        v-model="data.model.emadModalidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="data.form.condutaDesfecho"
                        :validations="validations.emadCondutaDesfecho"
                        label="Conduta/Desfecho"
                        show-default-option
                        text-field="descricao"
                        v-model="data.model.emadCondutaDesfechoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="data.additionals.criaFichaAtencaoBasicaAvaliacao && this.fichaAvaliacao && !data.additionals.hasAvaliacaoElegibilidade"
            background-color="secondary"
            title="Avaliaçăo de elegibilidade e admissăo - EMAD"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-select
                        :options="data.form.procedencias"
                        :validations="validations.emadProcedencia"
                        label="Procedência"
                        show-default-option
                        text-field="descricao"
                        v-model="data.model.emadProcedenciaId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col
                    v-if="!sugestao"
                    cols="8"
                >
                    <rkm-form-input-autocomplete
                        :repository="repositories.cid"
                        :request-query-string-params="{sexo: data.additionals.paciente.sexoIdentificador}"
                        :results-limit= "20"
                        :search-fields="fields.cid"
                        :text-field="(item) => `${item.codigo} - ${item.nome}`"
                        :validations="validations.cid"
                        label="CID 10"
                        v-model="data.model.emadCidPrimarioId"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group
                                    v-model="sugestao"
                                    :disabled="data.cidSugestao.length === 0"
                                >
                                    <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                    <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>

                <rkm-col
                    v-if="sugestao"
                    cols="8"
                >
                    <rkm-form-select
                        :options="data.cidSugestao"
                        :validations="validations.cid"
                        label="CID 10"
                        show-default-option
                        text-field="codigoNome"
                        v-model="data.model.emadSelectCidPrimarioId"
                        value-field="id"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group v-model="sugestao">
                                    <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                    <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-select>
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="data.form.cuidador"
                        label="Cuidador"
                        text-field="descricao"
                        v-model="data.model.emadCuidadorId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col
                    v-if="data.model.emadCuidadorId != enums.cuidador.NAO_POSSUI"
                    cols="4"
                >
                    <rkm-form-input
                        :disabled="!!data.model.emadCpfCuidador"
                        :validations="validations.cns"
                        label="CNS"
                        v-mask="mask.cns"
                        v-model="data.model.emadCnsCuidador"
                    />
                </rkm-col>

                <rkm-col
                    v-if="data.model.emadCuidadorId != enums.cuidador.NAO_POSSUI"
                    cols="4"
                >
                    <rkm-form-input
                        :disabled="!!data.model.emadCnsCuidador"
                        :validations="validations.cpf"
                        label="CPF"
                        v-mask="mask.cpf"
                        v-model="data.model.emadCpfCuidador"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="data.form.conclusao"
                        :validations="validations.emadConclusao"
                        label="Conclusão"
                        show-default-option
                        text-field="descricao"
                        v-model="data.model.emadConclusaoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="data.model.emadConclusaoId && data.model.emadConclusaoId != enums.conclusao.INELEGIVEL">
                <rkm-col>
                    <rkm-form-radio-group
                        :validations="validations.emadConclusaoJustificativa"
                        name="Justificativa"
                        v-model="data.model.emadConclusaoJustificativa"
                    >
                        <rkm-form-radio
                            v-for="justificativa in data.form.elegivel"
                            :key="justificativa.id"
                            :value="justificativa.id"
                        >
                            {{ justificativa.descricao }}
                        </rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="data.model.emadConclusaoId == enums.conclusao.INELEGIVEL">
                <rkm-col>
                    <rkm-form-checkbox-group
                        :validations="validations.emadConclusaoJustificativa"
                        name="Justificativa"
                        v-model="data.model.emadConclusaoJustificativa"
                    >
                        <rkm-form-checkbox
                            v-for="justificativa in data.form.inelegivel"
                            :key="justificativa.id"
                            :value="justificativa.id"
                        >
                            {{ justificativa.descricao }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <BoxDesfecho
            :data="data"
            :fila-id="filaId"
        />
    </rkm-area>
</template>

<script>
// Components.
import BoxCasoSuspeito from './components/caso-suspeito/Index'
import BoxDesfecho from './components/desfecho/Index'
import BoxProcedimentoAdministrativo from './components/procedimento-administrativo/Index'

// Mixins.
import {formats, repository, mask} from '@/mixins'

// Enums.
import conclusao from '@/enums/atencao-basica/avaliacao/conclusao'
import cuidador from '@/enums/atencao-basica/avaliacao/cuidador'
import demandaTipo from '@/enums/ambulatorio/demandaTipo'

export default {
    components: {
        BoxCasoSuspeito,
        BoxDesfecho,
        BoxProcedimentoAdministrativo,
    },
    computed: {
        validations() {
            return {
                atendimentoTipo: {required: true},
                consultaTipo: {required: true},
                equipe: {required: this.data.additionals.criaFichaAtencaoBasica},
                cid: {required: true},
                turno: {required: !!this.data.model.equipeId},
                atencaoBasicaLocalAtendimento: {required: !!this.data.model.equipeId},
                condutas: {
                    required:
                        this.data.model.casosSuspeitos.length === 0
                        && !!this.data.model.equipeId
                        && this.data.additionals.criaFichaAtencaoBasica
                },
                isTratamentoConcluido: {required: true},
                emadCondutaDesfecho: {required: true},
                emadTipoAtendimento: {required: true},
                emadModalidade: {required: true},
                emadProcedencia: {required: true},
                emadConclusao: {required: true},
                emadConclusaoJustificativa: {required: true},
                cns: {
                    min_max_without_mask: 15,
                    cns: true,
                    required: true,
                    not_same: this.data.additionals.paciente.cns
                },
                cpf: {
                    min_max_without_mask: 11,
                    cpf: true,
                    required: true,
                    not_same: this.data.additionals.paciente.cpf
                },
            }
        },
        fields() {
            return {
                cid: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
                usuario:  [
                    {key: 'cadastroCidadao.nome', searchable: true},
                ],
            }
        },
        atendimentoTipos() {
            if (!this.data.model.demandaTipo) {
                return []
            }

            if (this.data.model.demandaTipo === this.enums.demandaTipo.ESPONTANEA) {
                return this.data.form.atendimentoTipos.filter(t => t.isDemandaEspontanea)
            }

            return this.data.form.atendimentoTipos.filter(t => !t.isDemandaEspontanea)
        }
    },
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            cid: this.getConectaSusRepository('sigtap.cid'),
        }
        if(this.data.additionals.criaFichaAtencaoBasica && this.data.form.equipes.length == 1) {
            this.data.model.equipeId = this.data.form.equipes[0].id
        }
    },
    data: () => ({
        enums: {
            conclusao,
            cuidador,
            demandaTipo,
        },
        sugestao: false,
    }),
    mixins: [formats, repository, mask],
    props: {
        data: {type: Object, required: true},
        filaId: {type: Number, required: true},
        fichaAvaliacao: {type: Boolean, default: true},
    },
    watch: {
        'data.model.emadConclusaoId': function() {

            if(this.data.model.emadConclusaoId == this.enums.conclusao.INELEGIVEL) {

                this.data.model.emadConclusaoJustificativa = []
            } else {

                this.data.model.emadConclusaoJustificativa = null
            }
        },
        'sugestao': function() {

            if(this.sugestao) {

                this.data.model.emadCidPrimarioId = null
            } else {

                this.data.model.emadSelectCidPrimarioId = null
            }
        },
    }
}
</script>